export enum VehicleDataEnum {
    VEHICLE_PRODUCER = "VEHICLE_PRODUCER",
    VEHICLE_SERIES = "VEHICLE_SERIES",
    VEHICLE_MODEL = "VEHICLE_MODEL",
    VEHICLE_TYPE = "VEHICLE_TYPE",
    ECU_BUILD = "ECU_BUILD",
    ECU_PRODUCER = "ECU_PRODUCER"
}


export enum TableSourceEnum {
    DOWNLOAD_AND_DELETE_PURE = "DOWNLOAD_AND_DELETE_PURE",
    IMPORTS = "IMPORTS",
    PARTNER_IMPORTS = "PARTNER_IMPORTS",
    MASTER = "MASTER",
    PURE_ORIGINAL_BASE = "PURE_ORIGINAL_BASE",
    UPLOADING_RESULTS = "UPLOADING_RESULTS",
    "WIN_OLS_SOLUTIONS_TRANSACTIONS" = "WIN_OLS_SOLUTIONS_TRANSACTIONS",
    PURE_ORIGINAL_MISSING_VERSIONS ="PURE_ORIGINAL_MISSING_VERSIONS",
    PURE_ORIGINAL_MATCHING ="PURE_ORIGINAL_MATCHING",
    VERSION = "VERSION",
    PURE_ORIGINAL_LOSE_MATCHING ="PURE_ORIGINAL_LOSE_MATCHING",
    TUNING_NAMES = "TUNING_NAMES",

}


